import {HttpClient} from '@angular/common/http'
import {Injectable, inject} from '@angular/core'
import type {GalleryMedia} from '../entities/modals/api-modals/gallery-response.modal'
import {type Observable, firstValueFrom, of} from 'rxjs'
import {catchError, first, map} from 'rxjs/operators'
import {StorageType} from '@cart/src/app/entities/enums/storage-type.enum'
import {InfoService} from '@services/info.service'
import {UveStorageService} from '@services/uve-storage.service'
import {TagCloud} from '../entities/enums/tag-cloud.enum'
import {GalleryService} from './gallery.service'

@Injectable({
  providedIn: 'root',
})
export class AppNewsService {
  readonly #galleryService = inject(GalleryService)
  readonly #http = inject(HttpClient)
  readonly #infoService = inject(InfoService)
  readonly #uveStorageService = inject(UveStorageService)

  carrouselImages: GalleryMedia[]
  sliderTags: GalleryMedia

  setViewAppNews() {
    this.#uveStorageService.set(StorageType.localStorage, 'viewAppNews', 'true')
  }

  async getViewAppNews(): Promise<boolean> {
    const viewAppNews: boolean = await this.#uveStorageService.getAsync<boolean>(
      StorageType.localStorage,
      'viewAppNews'
    )
    return viewAppNews
  }

  async hasToRedirectAppNews(): Promise<boolean> {
    const appNewsViewed = await this.getViewAppNews()
    if (!this.#infoService.isWeb() && !appNewsViewed) {
      const data: string[] = await firstValueFrom(this.getLocalCarrouselImages())
      return data && data.length > 0
    }

    return false
  }

  getCarrouselImages(showloading = false): Observable<GalleryMedia[]> {
    this.carrouselImages = []

    const lang = 'es'
    let tag = TagCloud.carrouselCartEn
    if (lang === 'es') {
      tag = TagCloud.carrouselCartEs
    } else if (lang === 'ca') {
      tag = TagCloud.carrouselCartCa
    }

    return this.#galleryService.getGalleryImages(tag, showloading, '0').pipe(
      map((images: GalleryMedia[]) => {
        if (images && images.length > 0) {
          this.carrouselImages = images
        }
        return this.carrouselImages
      })
    )
  }

  getLocalCarrouselImages(): Observable<string[]> {
    return this.#http.get('assets/carrousel-images/version-news.json').pipe(
      first(),
      map(data => {
        return (data as string[]) ?? []
      }),
      catchError(() => of([]))
    )
  }
}
